<template>
    <div class="settingout mb-4">
        <h4 v-if="typeLabel == 'required'">{{ $t('managerForm.settingPage.settingRequiredLabel') }}</h4>
        <h4 v-if="typeLabel == 'confirm'">{{ $t('managerForm.settingPage.settingConfirmLabel') }}</h4>
        <div class="col-12">
            <div class="form-group row">
                <label v-if="typeLabel == 'required'" class="col-sm-2 mb-0"> 必須項目ラベル</label>
                <label v-if="typeLabel == 'confirm'" class="col-sm-2 mb-0"> 確認項目ラベル</label>
                <div class="col-sm-10">
                    <div class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                        <label class="col-sm-1 text-nowrap" style=""> 表示</label>
                        <div class="col-sm-10">
                            <div class="row align-items-center">
                                <InputRadio :model.sync="settingLabel.display" :id="`radio-display-1`" :value="1" label="表示する" class="mx-2" />
                                <InputRadio :model.sync="settingLabel.display" :id="`radio-display-2`" :value="0" label="表示しない" class="mx-2" />
                            </div>
                        </div>
                    </div>
                    <div v-if="settingLabel.display === 1" class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                        <label class="col-sm-1 text-nowrap" style="">{{ $t('managerForm.settingPage.labelButton') }}</label>
                        <div class="col-sm-10">
                            <InputText
                                :model.sync="settingLabel.label_required"
                                :config.sync="configEditLabelPage"
                                @blur="handleValidateField(configEditLabelPage)"
                            />
                        </div>
                    </div>
                    <div
                        v-if="settingLabel.display === 1 && typeLabel == 'required'"
                        class="form-group row"
                        style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px"
                    >
                        <label class="col-sm-1 text-nowrap" style=""> 表示位置 </label>
                        <div class="col-sm-10">
                            <div class="row align-items-center">
                                <InputRadio
                                    :model.sync="settingLabel.position"
                                    :id="`radio-position-1`"
                                    value="before"
                                    label="質問の前"
                                    class="mx-2"
                                />
                                <InputRadio
                                    :model.sync="settingLabel.position"
                                    :id="`radio-position-2`"
                                    value="after"
                                    label="質問の後"
                                    class="mx-2"
                                />
                            </div>
                        </div>
                    </div>
                    <div v-if="settingLabel.display === 1" class="form-group row" style="border-bottom: #d8d8d8 1px solid; padding-bottom: 20px">
                        <label class="col-sm-1 text-nowrap" style="min-width: 80px">フォント</label>
                        <div class="col-sm-3">
                            <Multiselect
                                :id="`select-qa_font`"
                                :value.sync="settingLabel.font"
                                :options="optionsDesign.fontFamily"
                                :config="configsDesign.configFieldSelectFont"
                            />
                        </div>
                        <div class="col-sm-1 px-0">
                            <InputText
                                :model.sync="settingLabel.font_size"
                                :config="configsDesign.configFieldFontSize"
                                @blur="handleValidateField(configsDesign.configFieldFontSize)"
                            />
                        </div>
                        <div class="col-sm-3">
                            <Multiselect
                                :id="`select-qa_font_styles`"
                                :value.sync="settingLabel.unit"
                                :options="optionsDesign.unitsNotIncludePercent"
                                :config="configsDesign.configFieldSelectUnits"
                            />
                        </div>
                    </div>
                    <div v-if="settingLabel.display === 1" class="form-group row">
                        <label class="col-sm-1 text-right">色</label>
                        <div class="d-flex col-sm-2" style="gap: 1rem">
                            <InputText
                                style="min-width: 100px"
                                :model.sync="settingLabel.color"
                                :config="{
                                    type: 'color',
                                    classCustom: 'form-control-color',
                                    error: false
                                }"
                            />
                            <InputText style="min-width: 100px" :model.sync="settingLabel.color" :config="configsDesign.configFieldColor" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { InputText, InputRadio } from '@/components/Input';
import Multiselect from '@/components/Multiselect/main.vue';
import { options as optionsDesign, configs as configsDesign } from '../../setting-design/constants';
// import { configEditLabelPage } from '../constants';
import { validateField } from '@/utils/validate';

export default {
    name: 'SettingLabel',
    components: {
        InputText,
        InputRadio,
        Multiselect
    },
    props: {
        typeLabel: {
            type: String,
            required: false,
            default: ''
        },
        settingLabel: {
            type: Object,
            required: true,
            default: () => null
        },
        configEditLabelPage: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            optionsDesign,
            configsDesign
        };
    },
    methods: {
        handleValidateField(configField) {
            validateField(configField);
        }
    },
    watch: {
        settingLabel: {
            handler() {
                if (this.settingLabel.display !== 1) {
                    // Reset errors when hiding the label settings
                    this.configEditLabelPage.error = false;
                    this.configEditLabelPage.message = '';
                }
            },
            deep: true
        }
    }
};
</script>
<style scoped></style>
